import React, { useState } from "react";
import ContactList from "./ContactList";
import ChatWindow from "./ChatWindow";

export default function Whatsapp() {
  const [contacts] = useState([
    { id: 1, name: "João Silva", lastMessage: "Beleza mano?", time: "10:15" },
    { id: 2, name: "Maria Oliveira", lastMessage: "Te mando o arquivo já já", time: "09:58" },
    { id: 3, name: "Lucas Santos", lastMessage: "Valeu!", time: "Ontem" },
  ]);

  const [selectedContact, setSelectedContact] = useState(contacts[0]);

  const [messages, setMessages] = useState([
    { id: 1, sender: "contact", text: "Olá! 👋 Como posso ajudar?", time: "10:01" },
    { id: 2, sender: "user", text: "Oi! Tudo bem?", time: "10:02" },
  ]);

  const handleSendMessage = (newMessage) => {
    const msg = {
      id: Date.now(),
      sender: "user",
      text: newMessage,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    setMessages((prev) => [...prev, msg]);
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "300px 1fr",
        backgroundColor: "#f0f2f5",
        borderRadius: "10px",
        overflow: "hidden",
        height: "85vh",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      <ContactList
        contacts={contacts}
        selectedContact={selectedContact}
        setSelectedContact={setSelectedContact}
      />
      <ChatWindow
        selectedContact={selectedContact}
        messages={messages}
        onSendMessage={handleSendMessage}
      />
    </div>
  );
}
